module.exports = __webpack_public_path__ + "8a13f3f599937779f86e63cfd29ec0b0.svg";